import type { MeResponse, OrganisationMembership } from '@immo/api-contract';

export function primaryMembership(me: MeResponse): OrganisationMembership | null {
  return me.organisations[0] ?? null;
}

export function membershipForWorkspace(me: MeResponse, workspaceId: string): OrganisationMembership | null {
  return me.organisations.find((entry) => entry.workspaceId === workspaceId) ?? null;
}

export function membershipForWorkspaceWithFallback(
  me: MeResponse | null,
  workspaceId: string,
): OrganisationMembership | null {
  if (me === null) return null;

  return membershipForWorkspace(me, workspaceId) ?? primaryMembership(me);
}
